/*
 * Copyright © 2017-Present, The Freshwater Trust, all rights reserved.
 */

import {Conditional} from "../../Conditional";
import {HelpIcon} from "../HelpIcon";
import React from "react";

export const PreConfirmationStatusHelpIcon = (props) => {
    const { confirmationStatusCode } = props;
    return <Conditional
        Condition={String(confirmationStatusCode) === "pre-confirmation"}>
        <HelpIcon backgroundColor="#FEFEFE">
            For Conservation Actions without As-Built Modeled Uplift, Eligibility or Design data will be shown if available.
        </HelpIcon>
    </Conditional>;
}
